import { useMemo, useState, useSyncExternalStore } from "react";
import config from "@/site.config.json";

export function DeckViewer({ deck, title }: { deck: { pptx: string; pdf: string; filename: string }; title: string }) {
  const [tab, setTab] = useState<"office" | "pdf">("pdf");
  const local = useSyncExternalStore(() => () => {}, () => ["localhost", "127.0.0.1"].includes(window.location.hostname), () => false);
  const activeTab = local || !config.office_viewer ? "pdf" : tab;
  const officeUrl = useMemo(() => {
    const absolute = `${config.site_url.replace(/\/$/, "")}${deck.pptx}`;
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(absolute)}`;
  }, [deck.pptx]);

  return (
    <section className="deck-section" aria-labelledby="deck-title">
      <div className="deck-heading">
        <div><p className="eyebrow">Lecture deck</p><h2 id="deck-title">Explore the presentation</h2></div>
        <div className="deck-actions"><a className="button secondary" href={deck.pptx} download>Download student PowerPoint</a><a className="button secondary" href={deck.pdf} download>Download PDF</a></div>
      </div>
      <p className="deck-boundary-note"><strong>Student edition.</strong> Instructor speaking notes and facilitation cues remain in the controlled teaching package and are not published here.</p>
      {local && <p className="viewer-notice">Local preview uses the PDF viewer. The Microsoft viewer activates on the deployed public site.</p>}
      <div className="tab-list" role="tablist" aria-label="Presentation format">
        <button role="tab" aria-selected={activeTab === "office"} aria-controls="office-panel" id="office-tab" onClick={() => setTab("office")} disabled={local || !config.office_viewer}>Interactive PowerPoint</button>
        <button role="tab" aria-selected={activeTab === "pdf"} aria-controls="pdf-panel" id="pdf-tab" onClick={() => setTab("pdf")}>Accessible PDF</button>
      </div>
      {activeTab === "office" ? (
        <div role="tabpanel" id="office-panel" aria-labelledby="office-tab" className="viewer-frame">
          <iframe title={`${title} interactive PowerPoint`} src={officeUrl} loading="lazy" allowFullScreen />
        </div>
      ) : (
        <div role="tabpanel" id="pdf-panel" aria-labelledby="pdf-tab" className="viewer-frame">
          <object data={deck.pdf} type="application/pdf" aria-label={`${title} PDF presentation`}><p>The PDF viewer is unavailable. <a href={deck.pdf}>Open the PDF directly</a>.</p></object>
        </div>
      )}
    </section>
  );
}
